import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '../config';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';

export const apiDriverAdministration = createApi({
    reducerPath: 'apiDriverAdministration',
    baseQuery: fetchBaseQuery({
        baseUrl: config.driverAdministrationApi,
        mode: 'cors',
        prepareHeaders,
    }),
    endpoints: () => ({}),
});
